<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <excess-stats></excess-stats>
      </v-flex>
      <v-flex xs12>
        <premium></premium>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import ExcessStats from '../query/ExcessStats'
import Premium from '../query/Premium'

export default {
  methods: {
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
      this.$router.push({ name: 'motorProposalVehicle' })
    },
    doProceed() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
      this.$router.push({ name: 'motorProposalPayment' })
    },
    async doPartialSave() {
      try {
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 4) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
    }
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  components: {
    ExcessStats,
    Premium
  }
}
</script>

<style lang="scss">

</style>
